/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ValuationLineMobile { 
    securityDefaultRatingRanking?: number;
    accountId?: string;
    securityId?: number;
    positionId?: number;
    description?: string;
    currencyId?: string;
    currencyExVId?: string;
    totalValuationIncludingInterest?: number;
    totalValuationExVIncludingInterest?: number;
    accrued?: number;
    accruedExV?: number;
    maxLevelClassification?: number;
    tradingAllowed?: boolean;
    assetClassType?: ValuationLineMobile.AssetClassTypeEnum;
    level1ClassificationId?: string;
    level1Description?: string;
    level1ShortDescription?: string;
    level1Ranking?: number;
    level2ClassificationId?: string;
    level2Description?: string;
    level2ShortDescription?: string;
    level2Ranking?: number;
    level3ClassificationId?: string;
    level3Description?: string;
    level3ShortDescription?: string;
    level3Ranking?: number;
    level4ClassificationId?: string;
    level4Description?: string;
    level4ShortDescription?: string;
    level4Ranking?: number;
    level5ClassificationId?: string;
    level5Description?: string;
    level5ShortDescription?: string;
    level5Ranking?: number;
    level6ClassificationId?: string;
    level6Description?: string;
    level6ShortDescription?: string;
    level6Ranking?: number;
    weighting?: number;
    units?: number;
    price?: number;
    priceDate?: string;
    grossPurchasePrice?: number;
    grossPurchasePriceExV?: number;
    netPurchasePrice?: number;
    netPurchasePriceExV?: number;
    grossCostPrice?: number;
    grossCostPriceExV?: number;
    netCostPrice?: number;
    netCostPriceExV?: number;
    inceptionDate?: string;
    isin?: string;
    yieldToMaturity?: number;
    commitment?: number;
    capitalCall?: number;
    capitalDistribution?: number;
    openCommitment?: number;
    performanceSinceInception?: number;
    capitalCalled?: number;
    capitalDistributed?: number;
    performanceSinceInceptionExV?: number;
    performanceNetSinceInception?: number;
    performanceNetSinceInceptionExV?: number;
    performanceGrossCostSinceInception?: number;
    performanceGrossCostSinceInceptionExV?: number;
    performanceNetCostSinceInception?: number;
    performanceNetCostSinceInceptionExV?: number;
    inceptionSecurityPerf?: number;
    inceptionExchangePerf?: number;
    inceptionSecurityAndExchangePerf?: number;
    positionType?: ValuationLineMobile.PositionTypeEnum;
    defaultSectorIdent?: string;
    defaultSectorDescription?: string;
    defaultSectorShortDescription?: string;
    positionPortfolioId?: string;
    ytdSecurityPerf?: number;
    ytdExchangePerf?: number;
    ytdSecurityAndExchangePerf?: number;
    mtdSecurityPerf?: number;
    mtdExchangePerf?: number;
    mtdSecurityAndExchangePerf?: number;
    defaultCountryIdent?: string;
    defaultCountryDescription?: string;
    defaultCountryShortDescription?: string;
    interestRate?: number;
    maturityDate?: string;
    securityDefaultRatingIdent?: string;
    securityDefaultRatingDescription?: string;
    identification?: string;
    netPurchasePriceProfitLossExV?: number;
}
export namespace ValuationLineMobile {
    export const AssetClassTypeEnum = {
        OTHER_SECURITY: 'OTHER_SECURITY',
        EQUITY: 'EQUITY',
        BONDS: 'BONDS',
        CONVERTIBLE: 'CONVERTIBLE',
        FUND: 'FUND',
        OPTION: 'OPTION',
        FUTURE: 'FUTURE',
        WARRANT: 'WARRANT',
        EQUITY_ETF: 'EQUITY_ETF',
        DERIVATIVE: 'DERIVATIVE',
        PRECIOUS_METAL: 'PRECIOUS_METAL',
        COMMODITIES: 'COMMODITIES',
        INDICE: 'INDICE',
        DEPOSIT_CERTIFICATE: 'DEPOSIT_CERTIFICATE',
        PRIVATE_EQUITY: 'PRIVATE_EQUITY',
        LIQUIDITY: 'LIQUIDITY',
        GUARANTEE: 'GUARANTEE',
        PLEDGE: 'PLEDGE',
        LIMIT: 'LIMIT',
        MONEY_MARKET: 'MONEY_MARKET',
        OTHER: 'OTHER',
        FOREX: 'FOREX',
        EQUITY_FUND: 'EQUITY_FUND',
        BOND_FUND: 'BOND_FUND',
        MONETARY_FUND: 'MONETARY_FUND',
        MIXED_FUND: 'MIXED_FUND',
        REAL_ESTATE_FUND: 'REAL_ESTATE_FUND',
        HEDGE_FUND: 'HEDGE_FUND',
        OTHER_FUND: 'OTHER_FUND',
        BOND_ETF: 'BOND_ETF',
        MORTGAGE_BACKED_SECURITIES: 'MORTGAGE_BACKED_SECURITIES',
        BONDS_FLOATING: 'BONDS_FLOATING',
        INTEREST_FUTURE: 'INTEREST_FUTURE',
        INTEREST_OPTION: 'INTEREST_OPTION',
        INTEREST_DERIVATIVES: 'INTEREST_DERIVATIVES',
        CREDIT_FUTURE: 'CREDIT_FUTURE',
        CREDIT_OPTION: 'CREDIT_OPTION',
        CREDIT_DERIVATIVES: 'CREDIT_DERIVATIVES',
        FOREX_FUTURE: 'FOREX_FUTURE',
        FOREX_OPTION: 'FOREX_OPTION',
        STRUCTURED_PRODUCT: 'STRUCTURED_PRODUCT',
        EQUITY_FUTURE: 'EQUITY_FUTURE',
        EQUITY_OPTION: 'EQUITY_OPTION',
        EQUITY_DERIVATIVE: 'EQUITY_DERIVATIVE',
        COMMODITIES_FUTURE: 'COMMODITIES_FUTURE',
        COMMODITIES_OPTION: 'COMMODITIES_OPTION',
        CONTRACT_FOR_DIFFERENCE: 'CONTRACT_FOR_DIFFERENCE',
        COMMODITIES_ETF: 'COMMODITIES_ETF',
        OTHER_ETF: 'OTHER_ETF',
        COMMODITIES_FUND: 'COMMODITIES_FUND',
        PRIVATE_EQUITY_FUND: 'PRIVATE_EQUITY_FUND',
        BONDS_FUTURE: 'BONDS_FUTURE',
        BONDS_OPTION: 'BONDS_OPTION',
        BONDS_DERIVATIVE: 'BONDS_DERIVATIVE'
    } as const;
    export type AssetClassTypeEnum = typeof AssetClassTypeEnum[keyof typeof AssetClassTypeEnum];
    export const PositionTypeEnum = {
        SECURITY: 'SECURITY',
        ACCOUNT: 'ACCOUNT',
        FIDUCIARY: 'FIDUCIARY',
        EXCHANGE: 'EXCHANGE',
        TREASURY: 'TREASURY',
        CONTRACT: 'CONTRACT'
    } as const;
    export type PositionTypeEnum = typeof PositionTypeEnum[keyof typeof PositionTypeEnum];
}


